import React, { FC, useCallback } from "react";
import { ITextInputProps } from "../TextInput/TextInput.interface";
import creditCardNumberParser from "../inputMasks/creditCardNumberParser";
import normalizeCardNumber from "../inputMasks/normalizeCardNumber";
import TextInput from "../TextInput/TextInput";
import InputAdornment from "../InputAdornment/InputAdornment";
import Model, { IModel } from "../../../Utility/Model/Model";
import SvgIcon from "../../../Icons/SvgIcon";

export const isCardValid = (v: string): boolean => v.length === 16;

export interface ICreditCardInputProps
  extends ITextInputProps,
    Pick<IModel, "onModelChange"> {
  validityChecker?(val: ITextInputProps["value"]): boolean;
}

const CreditCardInput: FC<ICreditCardInputProps> = ({
  value,
  validityChecker = isCardValid,
  onChange: originalOnChange,
  onModelChange,
  ...inputProps
}) => {
  const EndAdornment = useCallback(
    ({ parsedValue, ...injectedProps }) => (
      <InputAdornment
        {...injectedProps}
        classes={{ root: !parsedValue ? "d-none" : "" }}
        position="end"
        hideOnFocus={false}
      >
        <SvgIcon
          icon="MastercardColoredIcon"
          className="icon-mastercard-colored"
          data-testid="credit-card-icon"
        />
      </InputAdornment>
    ),
    [],
  );
  return (
    <Model
      value={value}
      parser={creditCardNumberParser}
      formatter={normalizeCardNumber}
      onChange={originalOnChange}
      onModelChange={onModelChange}
      {...inputProps}
    >
      {({ parsedValue, formattedValue, onChange, ...rest }) => (
        <TextInput
          label="Credit card"
          placeholder="4444 4444 4444 4444"
          type="tel"
          validity={
            rest.validity ?? (validityChecker(parsedValue) ? "valid" : "error")
          }
          autoComplete="cc-number"
          errorMessage="Please enter a correct credit card number"
          value={formattedValue}
          hideRightIconOnFocus="show"
          /* eslint-disable-next-line react/no-unstable-nested-components */
          endAdornment={(injectedProps) => (
            <EndAdornment parsedValue={parsedValue} {...injectedProps} />
          )}
          onChange={onChange}
          {...rest}
        />
      )}
    </Model>
  );
};

export default CreditCardInput;
